import axios from "axios";

const baseurl = "/_app/"

export function entityGet(name, parameters, callbackSuccess, callbackError) {
  var url =  baseurl + name;
  const queryString = encodeQueryData(parameters);
  if (queryString) {
    url += "?" + queryString;
  }

  axios( { method: 'GET', url: url})
    .then(function(response) {
      callbackSuccess(response.data);
    })
    .catch(function(error) {
      callbackError(error);
    });
}


export function entityPost(name, data, callbackSuccess, callbackError) {
  entityPostPut('POST', name, data, callbackSuccess, callbackError);
}

export function entityPut(name, data, callbackSuccess, callbackError) {
  entityPostPut('PUT', name, data, callbackSuccess, callbackError);
}

function entityPostPut(method, name, data, callbackSuccess, callbackError ) {
  var url = baseurl + name;

  axios( { method: method, url: url, data: data})
    .then(function(response) {
      callbackSuccess(response);
    })
    .catch(function(error) {
      callbackError(error);
    });


}


function encodeQueryData(data) {
   let ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}



// WEBPACK FOOTER //
// ./src/entity/Entity.jsx